var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsCloudFormationStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cd2264;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AWS-CloudFormation_Stack_light-bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reference"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.5,16.16H1.5V2h47Zm-45-2h43V4H3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.12,32.09H1.5V17.91H24.12Zm-20.62-2H22.12V19.91H3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.69,48H1.5V33.84H15.69ZM3.5,46H13.69V35.84H3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.56,48H17.44V33.84H32.56ZM19.44,46H30.56V35.84H19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.5,48H34.31V33.84H48.5ZM36.31,46H46.5V35.84H36.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.5,32.09H25.88V17.91H48.5Zm-20.62-2H46.5V19.91H27.88Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudFormationStack);
export default __webpack_public_path__ + "static/media/AWS-CloudFormation_Stack.51a909be95c06677bdf56513d32086db.svg";
export { ForwardRef as ReactComponent };